import { render } from "./basicExample.vue?vue&type=template&id=6b2d1571"
import script from "./basicExample.vue?vue&type=script&lang=js"
export * from "./basicExample.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__